import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from './header';
import Sidebar from './sidebar';
import { loadGoogleMaps } from '../utils/loadGoogleMaps'; // Ensure this path is correct
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { Select } from 'antd';

const HouseLocation = () => {
  const [houses, setHouses] = useState([]);
  const [error, setError] = useState(null);
  const navigate = useNavigate(); // Initialize useNavigate
  const [munToleId, setMunToleId] = useState(null);
  const [toleOptions, setToleOptions] = useState([]);
  
  const API_URL = 'https://ward3-chandrapur-api.palikaapp.com/api/house/all';
  const FILTER_URL = 'https://ward3-chandrapur-api.palikaapp.com/api/house/filter-tole';

  // Fetch tole options for the filter dropdown
  useEffect(() => {
    const fetchToles = async () => {
      try {
        const response = await axios.get("https://ward3-chandrapur-api.palikaapp.com/api/mun-tole/all"); // Adjust this endpoint as necessary
        setToleOptions(response.data);
      } catch (error) {
        console.error('Error fetching tole options', error);
      }
    };
    fetchToles();
  }, []);

  // Fetch houses based on the selected munToleId
  useEffect(() => {
    const fetchHouses = async () => {
      try {
        console.log("Fetching houses with Mun Tole ID:", munToleId);
        const response = await axios.get(FILTER_URL, {
          params: { munTole: munToleId }, // Include munToleId if filtering
        });

        console.log("Filtered houses response:", response.data); // Log the response

        // Set houses state to the content array
        setHouses(response.data.content); // Accessing the content array for houses

      } catch (error) {
        console.error("Error fetching houses:", error);
        setError(error);
      }
    };

    if (munToleId) {
      fetchHouses();
    } else {
      // Fetch all houses if no filter is applied
      const fetchAllHouses = async () => {
        try {
          const response = await axios.get(API_URL);
          console.log("All houses response:", response.data); // Log the response
          setHouses(response.data); // Adjust if the API returns a nested structure as well
        } catch (error) {
          console.error("Error fetching all houses:", error);
          setError(error);
        }
      };
      fetchAllHouses();
    }
  }, [munToleId]);

  useEffect(() => {
    const initMap = async () => {
      try {
        const googleMaps = await loadGoogleMaps("AIzaSyB4Z418MHwoKYfrN9wq28zZvgqtfwmNXa4"); // Replace with your API key

        const firstHouse = houses[0];
        const mapCenter = firstHouse
          ? { lat: parseFloat(firstHouse.latitude), lng: parseFloat(firstHouse.longitude) }
          : { lat: 27.7000, lng: 85.3000 };

        const map = new googleMaps.Map(document.getElementById("map"), {
          zoom: 12,
          center: mapCenter,
          mapTypeId: "terrain",
        });

        if (window.existingMarkers) {
          window.existingMarkers.forEach(marker => marker.setMap(null));
        }

        window.existingMarkers = [];

        houses.forEach(house => {
          const marker = new googleMaps.Marker({
            position: { lat: parseFloat(house.latitude), lng: parseFloat(house.longitude) },
            map: map,
            icon: {
              url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
            },
            title: house.ownerNameNep,
          });

          window.existingMarkers.push(marker);

          // Hover event to change marker color
          const infowindow = new googleMaps.InfoWindow({
            content: `<div style="font-weight: bold; color: #000;">
                        क्र.सं: ${house.id}<br/>
                        नाम: ${house.ownerNameNep}<br/>
                        टोल: ${house.munToleName}
                      </div>`,
          });

          marker.addListener('mouseover', () => {
            infowindow.open(map, marker);
            marker.setIcon({
              url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
            });
          });

          marker.addListener('mouseout', () => {
            infowindow.close();
            marker.setIcon({
              url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
            });
          });

          // Click event to go to house details using useNavigate
          marker.addListener('click', () => {
            navigate(`/house/${house.id}/details`); // Programmatically navigate to house details
          });
        });
      } catch (error) {
        console.error("Failed to load Google Maps:", error);
      }
    };

    if (houses.length > 0) {
      initMap();
    }
  }, [houses, navigate]); // Add navigate as a dependency

  const containerStyle = {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
    maxWidth: '1200px',
    margin: '90px auto',
    marginTop: '80px',
    marginLeft: '250px',
  };

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <div>
      <Sidebar />
      <Header />
      <div style={containerStyle}>
        <h1>घरहरुको स्थान</h1>
        
        {/* Tole filter dropdown */}
        <div style={{ marginBottom: '20px' }}>
  <label htmlFor="tole-select">टोल चयन गर्नुहोस्: </label>
  <Select
    id="tole-select"
    value={munToleId}
    onChange={(value) => setMunToleId(value)}
    placeholder="Select Tole"
    style={{ width: '200px', marginLeft: '10px' }} // Adjust width as needed
  >
    {toleOptions.map((tole) => (
      <Select.Option key={tole.id} value={tole.id}>
        {tole.name}
      </Select.Option>
    ))}
  </Select>
</div>


        <div
          id="map"
          style={{
            height: '600px',
            width: '100%',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
          }}
        ></div>
      </div>
    </div>
  );
};

export default HouseLocation;
